// extracted by mini-css-extract-plugin
module.exports = {"fullWidthLogoContainer":"Components_fullWidthLogoContainer__3crDh","logoContainer":"Components_logoContainer__nzOSR"};